import { Badge } from "@/components/ui/badge";
import { ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

interface VehicleGroupHeaderProps {
  vehicle: {
    id: string;
    plate: string;
    make?: string;
    model?: string;
  };
  plansCount: number;
  openOrdersCount: number;
  isOpen: boolean;
}

export function VehicleGroupHeader({
  vehicle,
  plansCount,
  openOrdersCount,
  isOpen,
}: VehicleGroupHeaderProps) {
  return (
    <div className="flex items-center justify-between p-4 hover:bg-accent/50 cursor-pointer transition-colors">
      <div className="flex items-center gap-3">
        <ChevronRight 
          className={cn(
            "h-5 w-5 transition-transform duration-200",
            isOpen && "rotate-90"
          )}
        />
        <div>
          <h3 className="font-semibold text-lg">
            {vehicle.plate}
            {vehicle.make && vehicle.model && (
              <span className="text-muted-foreground font-normal ml-2">
                {vehicle.make} {vehicle.model}
              </span>
            )}
          </h3>
        </div>
      </div>
      
      <div className="flex items-center gap-2">
        <Badge variant="secondary">
          {plansCount} {plansCount === 1 ? 'plano' : 'planos'}
        </Badge>
        
        {openOrdersCount > 0 && (
          <Badge variant="destructive">
            {openOrdersCount} OS {openOrdersCount === 1 ? 'aberta' : 'abertas'}
          </Badge>
        )}
      </div>
    </div>
  );
}
